import {Service, Module} from 'app/decorators.js';
import R from 'app/resource';
import BaseStore from './base';


@Module({
    name: 'app.store.dispatch',
    modules: [
        R,
    ],
})
@Service('DispatchStore')
export default class Store extends BaseStore {

    constructor ($q, R) {
        "ngInject";
        super($q, R);
        this.endpoint = this.R.all('dispatch');
    }

}



// WEBPACK FOOTER //
// ./src/app/stores/dispatch.js